import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { ISkyApiConfig } from './interface';

export const SKY_API_CONFIG = new InjectionToken<ISkyApiConfig>('libs.shared.api.config');
export const SKY_API_CACHE_CONTEXT_TOKEN = new HttpContextToken<boolean>(() => false);
